import { useParams } from 'react-router-dom';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { useSavePlaylist, useSetHiddenForOwner, useUnsavePlaylist } from '.';
import { usePlaylist } from '../savedItems';
export const useMyPlaylistsParams = () => {
  const {
    page,
    tab
  } = useParams();
  return {
    page,
    tab: tab || 'all'
  };
};
export const useMyPlaylistsFilters = () => {
  const [[selectedCreatedBy]] = useSearchParam(FILTER_TYPES.CREATED_BY);
  const [[searchFilter]] = useSearchParam(FILTER_TYPES.SEARCH);
  const [[sortBy]] = useSearchParam(FILTER_TYPES.SORT_BY_MY_PLAYLISTS);
  return {
    selectedCreatedBy,
    searchFilter,
    sortBy
  };
};
export const usePlaylistSaveStatus = (playlistId, {
  showNotification,
  language
} = {}) => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const isSaved = playlist && playlist.savedByUser;
  const [savePlaylist] = useSavePlaylist(playlistId, {
    showNotification,
    language
  });
  const [unsavePlaylist] = useUnsavePlaylist(playlistId, {
    showNotification,
    language
  });
  const togglePlaylistSaveStatus = () => {
    if (isSaved) return unsavePlaylist();else return savePlaylist();
  };
  return {
    isSaved,
    isLoading: playlistLoading,
    togglePlaylistSaveStatus
  };
};
export const usePlaylistArchivedStatus = (playlistId, {
  showNotification,
  language
} = {}) => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const isArchived = playlist && playlist.hiddenForOwner;
  const [toggleHiddenForOwner] = useSetHiddenForOwner(playlistId, playlist !== null && !playlist.hiddenForOwner, {
    showNotification,
    language
  });
  return {
    isArchived,
    isLoading: playlistLoading,
    togglePlaylistArchivedStatus: toggleHiddenForOwner
  };
};